import { useState } from "react"
import Image, { ImageProps } from "next/image"
import { Highlight } from "@ui"

interface ImageWithHighlightProps extends ImageProps {
  image?: Partial<ImageProps>
  onLoadingComplete?: () => void
  preloaderBgClassName?: string
}

export const ImageWithHighlight = (props: ImageWithHighlightProps) => {
  const { src, width, height, layout, objectFit, alt, image } = props
  const [isPreloaderShowed, setPreloaderVisibility] = useState(true)
  function hidePreloader(): void {
    setPreloaderVisibility(false)
  }

  return (
    <div className="relative w-full h-full">
      <Image
        src={src}
        width={width}
        height={height}
        layout={layout}
        objectFit={objectFit}
        alt={alt}
        unoptimized={true}
        onLoadingComplete={() => hidePreloader()}
        {...image}
      />
      {isPreloaderShowed && <Highlight />}
    </div>
  )
}
